$(function(){

    $(document).on('click', '.facet-filters__label', function () {
        const $this = $(this);
        const $currentUl = $this.siblings('ul, .sort_list');

        $('.facet-toggle ul, .sort_list').not($currentUl).hide();
        $('.facet-filters__label').not($this).removeClass('on')
            .find('svg').css('transform','rotate(0deg)');

        $currentUl.toggle();

        if ($this.hasClass('on')) {
            $this.removeClass('on');
            $this.find('svg').css('transform','rotate(0deg)');
        } else {
            $this.addClass('on');
            $this.find('svg').css('transform','rotate(180deg)');
        }
    });

    const params = new URLSearchParams(window.location.search);
    const sortBy = params.get('sort_by');

    if (sortBy) {
        $('.facet-filters__field .sort_list li').removeClass('active');

        $('.facet-filters__field .sort_list li[value="' + sortBy + '"]')
            .addClass('active');
    }


   $('.sort_list li').on('click', function() {
        const value = $(this).attr('value');
        const nowUrl = new URL(window.location.href);
        nowUrl.searchParams.set('sort_by', value);
        window.location.href = nowUrl.toString();
    });

    $('.mobile-facets__wrapper .mobile_sort_btn').on('click',()=>{
        $('.mobile-facets__wrapper .sort_list').addClass('on');
        $('body').prepend('<div class="filterBg"></div>');
    })

    $('.mobile-facets__wrapper .sort_list p').on('click', () => {
        $('.mobile-facets__wrapper .sort_list').removeClass('on');
        $('.filterBg').remove();
    });

    $(document).on('click', '.filterBg', () => {
        $('.mobile-facets__wrapper .sort_list').removeClass('on');
        $('.filterBg').remove();
    });

})